(function (exports) {

	'use strict';

	exports.Storage = {
		fetch: function (STORAGE_KEY) {
			return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]')
		},
    store: function (STORAGE_KEY, data) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
    },
	}

})(window)